import Model from '@/lib/data/Model';

class IndustryClassification extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'parent_id' },
        { name: 'code' },
        { name: 'parent_code' },
        { name: 'name' },
        { name: 'type' },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default IndustryClassification;
